import { defineStore } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useTestsStore, useQuestionsStore } from '@stores';
import { useToast } from 'primevue/usetoast';
import { getAnswerIdFetch, updateAnswerFetch, deleteAnswerFetch } from '@services/testService';

export const useAnswersStore = defineStore('useAnswersStore', () => {
    const toast = useToast();
    const { t } = useI18n({ useScope: 'global' });
    const testsStore = useTestsStore();
    const questionsStore = useQuestionsStore();

    const addAnswer = async () => {
        const answerId = await getAnswerIdFetch({ question_id: questionsStore.selectedId });
        const answerArray = testsStore.main.selectedLanguages.map((lang) => ({ language: lang, content: null }));

        const newAnswer = {
            order: questionsStore.question.answers.length + 1,
            answer_id: answerId,
            answer: answerArray,
            isCorrect: false,
        };

        const isAnswerExist = questionsStore.question.answers.some((q) => q.answer_id === answerId);

        if (!isAnswerExist) {
            questionsStore.question.answers.push({ ...newAnswer });
        } else {
            toast.add({ severity: 'error', detail: t('userCreate.required'), life: 3000 });
        }
    };

    const updateAnswerOrder = async (index) => {
        const draggedQuestion = { ...questionsStore.question.answers[index], order: index + 1, question_id: questionsStore.selectedId };
        try {
            await updateAnswerFetch(draggedQuestion);
            questionsStore.question.answers.forEach((q, i) => (q.order = i + 1));
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    const updateAnswer = async (answer, value) => {
        const updatedAnswer = { ...answer, ...value, question_id: questionsStore.selectedId };
        try {
            await updateAnswerFetch(updatedAnswer);
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    const deleteAnswer = async (answer_id) => {
        try {
            await deleteAnswerFetch({ question_id: questionsStore.selectedId, answer_id });
            questionsStore.question.answers = questionsStore.question.answers.filter((a) => a.answer_id !== answer_id);
        } catch (e) {
            toast.add({ severity: 'error', summary: t('form.error'), detail: t('form.errors.' + e.response.data.message), life: 3000 });
        }
    };

    return {
        addAnswer,
        updateAnswerOrder,
        updateAnswer,
        deleteAnswer,
    };
});
